// Using crypto-js instead of Node.js crypto for browser compatibility
import { HmacSHA256 } from 'crypto-js'
import { enc } from 'crypto-js'

export type GenerateFloatOptions = {
  clientSeed: string
  serverSeed: string
  nonce: number
  round?: number
}

export default function generateFloat(options: GenerateFloatOptions) {
  const { clientSeed, serverSeed, nonce, round = 0 } = options

  // Create HMAC using crypto-js
  const hmacString = HmacSHA256(
    `${clientSeed}:${nonce}:${Math.floor(round / 8)}`,
    serverSeed
  ).toString(enc.Hex)

  // Convert hex string to bytes array
  const buffer = new Uint8Array(
    hmacString.match(/.{1,2}/g)!.map((byte) => parseInt(byte, 16))
  )

  const startIndex = (round % 8) * 4

  let result = 0

  for (let i = 0; i < 4; i++) {
    const value = buffer[startIndex + i]
    const divider = 256 ** (i + 1)
    const partialResult = value / divider
    result += partialResult
  }

  return result
}
